<template>
  <div class="stepBox">
    <qiangzhi :type="3" />
    <fengxian :type="3" />
    <div class="step" :class="{ step1: grade == 3 }">
      <fuwu :style="grade == 3 ? '--background:transparent' : '#fff'" isshi/>
      <hetongbao ref="hetongbao" v-show="hetongbaoshow" />
    </div>

    <mElectronicFooter disabledNext/>
  </div>
</template>

<script>
import mixins from "./mixins";
import hetongbao from "@/views/ContractInsurance/hetongbao.vue";
import { mapState } from "vuex";
export default {
  components: {
    hetongbao,
  },
  mixins: [mixins],
  data() {
    return {
      hetongbaoshow: true,
    };
  },
  created() {},
  computed: {
    ...mapState("insuranceSelect", ["grade"]),
  },
  methods: {},
};
</script>

<style scoped lang="scss">
@use "~@/views/hetongqianshu/step/index.scss" as *;
.step1 {
  background-color: #3e3e64 !important;
}
</style>
